export const isUndefinedNullOrEmpty = (value: any) => {
   if (!value) {
      return true;
   }
   else if (Array.isArray(value)) {
     return value.length === 0;
   } 
   else if (typeof value === 'object') {
     return Object.keys(value).length === 0;
   }
   return false;
 }

 export default isUndefinedNullOrEmpty;
 